import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./Learner.css";
import LearnerSearchForm from './LearnerSearchForm';
import SearchView from "../../widgets/SearchView";
import { ViewContainer } from "./../../View.jsx";
import withMenuPermission from "../../widgets/withMenuPermission";


const headCells = [
    { id: 'FirstName', numeric: false, disablePadding: false, label: 'First Name' },
    { id: 'MiddleName', numeric: false, disablePadding: false, label: 'Middle Name' },
    { id: 'Surname', numeric: false, disablePadding: false, label: 'Surname' },
    { id: 'IDNo', numeric: false, disablePadding: false, label: 'ID Number' },
    { id: 'PhysicalProvince', numeric: false, disablePadding: false, label: 'Physical Province' }
];



class LearnerSearch extends Component {

    constructor(props) {
        super(props)
        
    }

    state = {
        model: {
            FirstName: "",
            MiddleName: "",
            Surname: "",
            IDNo: "",
            PhysicalProvinceID: "0",
            InterventionListID: "0",
            LearnerAvailabilityID: "0"
        },
        searchParameters: [{ Name: "FirstName", Value: "" },
                            { Name: "MiddleName", Value: "" },
                            { Name: "Surname", Value: "" },
                            { Name: "IDNo", Value: "" },
                            { Name: "PhysicalProvinceID", Value: "0" },
                            { Name: "InterventionListID", Value: "0" },
                            { Name: "LearnerAvailabilityID", Value: "0" }],
        selection: [],
        keyUpSwitch: false, 
        toolbarConfig: {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Capture New Learner', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add},
                        { id: 'edit', label: '', tooltip: 'Update Current Learner', icon: 'EditIcon',  visible: this.props.menuPermissionItem.Edit}
                       
                    ]
                }
            ]
        }
    };

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }
    
    render() {
 
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells} dataUrl="api/sims/Learner/GetSearch" entityViewPath='/learner' addViewPath='/addLearnerFlow'
                    model={this.state.model} toolbarConfig={this.state.toolbarConfig} searchParameters={this.state.searchParameters}
                    onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="FirstName"
                    SecondDescriptionProp = "Surname" 
                    mode={this.props.mode}
                    handleObject={true}
                    autoFetchData={false}
                    history={this.props.history}
                    keyUpSwitch={this.state.keyUpSwitch}
                    multiSelect={this.props.multiSelect}
                    title='Learner' 
                >
                    <LearnerSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(LearnerSearch));

